import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { svuotaRaccoglitore } from "@/lib/raccoglitore";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (!cancelled) setUser(data);
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("Auth check failed:", error?.response?.status || error?.message);
        }
        if (!cancelled) setUser(null);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("sgm_token", data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (error) {
      if (process.env.NODE_ENV !== "production") {
        console.warn("Logout request failed:", error?.message);
      }
    }
    localStorage.removeItem("sgm_token");
    // Quello che era rimasto nel raccoglitore se ne va con la sessione: ci
    // passano anche documenti personali, e il computer e' spesso condiviso.
    svuotaRaccoglitore();
    setUser(null);
  };

  const value = useMemo(
    () => ({ user, login, logout, isAdmin: user?.role === "admin" }),
    [user]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
